
import {createAuthQrCode,fansGroupGoodListData,addFansGroupGood,delFansGroupGood,getFansGroupGood,fansGroupListData,authInfoListData,createFansGroup,saveAuthInfo} from "@/zsm-api-new/interact"
const state = {

}

const mutations = {

}

const actions = {
  
  /**
 * 绑定粉丝群关联课程关联课程
 *  @param id  主键ID
 *  @returns {*}
 */
  fansGroupGoodListData({ commit }, info) {
    return new Promise((resolve, reject) => {
      fansGroupGoodListData(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
},

  /**
 * 创建群绑定账号二维码
 *  @param mobile  手机号
 *  @returns {*}
 */
  createAuthQrCode({ commit }, info) {
    return new Promise((resolve, reject) => {
      createAuthQrCode(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
},

/**
 * 绑定粉丝群关联课程关联课程
 *  @param id  主键ID
 *  @returns {*}
 */
 addFansGroupGood({ commit }, info) {
    return new Promise((resolve, reject) => {
      addFansGroupGood(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
},
    /**
 * 查询单条粉丝群数据
 *  @param id  群Id
 *  @returns {*}
 */
    delFansGroupGood({ commit }, info) {
      return new Promise((resolve, reject) => {
        delFansGroupGood(info).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  /**
 * 查询单条粉丝群数据
 *  @param id  群Id
 *  @returns {*}
 */
  getFansGroupGood({ commit }, info) {
  return new Promise((resolve, reject) => {
    getFansGroupGood(info).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
},

/**
 * 创建群
 *  @param mobile   手机号 
 *  @param groupName    群名称 
 *  @param description   群介绍 
 *  @param avatarMaterial.materialUrl  头像url
 *  @param userId    授权过的用户的userId == open_id 
 *  @param {Array} fansGroupGoodList   关联课程 
 *  @returns {*}
 */
createFansGroup({ commit }, info) {
  return new Promise((resolve, reject) => {
    createFansGroup(info).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
},


  
/**
 * 保存授权信息
 *  @param mobile   手机号 
 *  @param openId   openId 
 *  @param accessCode   授权码 
 *  @returns {*}
 */
saveAuthInfo({ commit }, info) {
  return new Promise((resolve, reject) => {
    saveAuthInfo(info).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
},

/**
 * 授权信息分页数据
 *  @param mobile   手机号 
 *  @returns {*}
 */
 authInfoListData({ commit }, info) {
  return new Promise((resolve, reject) => {
    authInfoListData(info).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
},
 /**
 * 查询粉丝群分页数据
 *  @param groupName  群名称,
 *  @param groupStatus 群状态
 *  @param mobile   手机号 
 *  @returns {*}
 */
 fansGroupListData({ commit }, info) {
    return new Promise((resolve, reject) => {
        fansGroupListData(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



export default {
  namespaced: true,
  state,
  mutations,
  actions
}
